// Marketing source tracking — first-party only, sessionStorage.
// Captures ?ref= and utm_* from the landing URL. Never touches localStorage
// or cookies. Idempotent — later empty visits don't overwrite an existing ref.

const KEY = "gs_ref";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

export function captureFromLocation(location) {
  try {
    const params = new URLSearchParams(location.search || "");
    const incoming = {
      ref: params.get("ref"),
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
    };
    const anyIncoming =
      incoming.ref ||
      UTM_KEYS.some((k) => incoming[k] && incoming[k].length > 0);
    if (!anyIncoming) return loadSource();

    const now = new Date().toISOString();
    const record = {
      ref: incoming.ref || null,
      utm_source: incoming.utm_source || null,
      utm_medium: incoming.utm_medium || null,
      utm_campaign: incoming.utm_campaign || null,
      first_seen_at: now,
      landing_path: location.pathname || "/",
    };
    sessionStorage.setItem(KEY, JSON.stringify(record));
    return record;
  } catch {
    return null;
  }
}

export function loadSource() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
